/**
 * A server action that calls redirect() rejects on the CLIENT with an
 * error whose digest (and message) is "NEXT_REDIRECT". The auth forms
 * wrap their actions in try/catch inside useActionState reducers so
 * expected failures render as form errors — but that catch must not
 * swallow redirects, or the user sees a literal "NEXT_REDIRECT" error
 * and the navigation never happens (2026-08-30 staging QA: login with
 * valid credentials appeared to fail). Call this first in every such
 * catch: it rethrows redirect errors so the Next router performs the
 * navigation, and returns for everything else.
 */
export function rethrowIfRedirect(e: unknown): void {
  if (!e || typeof e !== 'object') return
  const digest = (e as { digest?: unknown }).digest
  const message = (e as { message?: unknown }).message
  if (
    (typeof digest === 'string' && digest.startsWith('NEXT_REDIRECT')) ||
    message === 'NEXT_REDIRECT'
  ) {
    throw e
  }
}
